export enum ShareButtonCodes {
  INSTA = 'insta',
  FACEBOOK = 'facebook',
  TELEGRAM = 'telegram',
  VK = 'vk',
}
